import { erpAxios } from '.';

const getDates = async (kreditBroj) => {
  const { data } = await erpAxios.get(`/costsAndDates/getDates/${kreditBroj}`);
  return data;
};

export default getDates;
